var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5941 9.72408V6.03155C17.5941 5.56013 17.2204 5.1775 16.76 5.1775H1.8267C1.22096 5.1775 0.719032 4.71984 0.632324 4.12463",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6021 5.1775V2.51032C14.6021 1.34617 13.547 0.484618 12.4393 0.742208L1.26127 3.34061C0.885127 3.42814 0.618896 3.76951 0.618896 4.16465V17.0154C0.618896 17.4868 0.992596 17.8694 1.453 17.8694H16.76C17.2205 17.8694 17.5942 17.4868 17.5942 17.0154V13.1678",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0676 9.80457H18.5846C18.7458 9.80457 18.8764 9.93836 18.8764 10.1034V12.7568C18.8764 12.9219 18.7458 13.0557 18.5846 13.0557H16.0676C15.192 13.0557 14.48 12.3267 14.48 11.4301C14.48 10.5336 15.192 9.80457 16.0676 9.80457Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1897 11.9303C16.4595 11.9303 16.6782 11.7063 16.6782 11.4301C16.6782 11.1539 16.4595 10.9299 16.1897 10.9299C15.9199 10.9299 15.7012 11.1539 15.7012 11.4301C15.7012 11.7063 15.9199 11.9303 16.1897 11.9303Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBlue);
export default __webpack_public_path__ + "static/media/WalletBlue.8e70602bc9d097272a707794e5934070.svg";
export { ForwardRef as ReactComponent };